function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageresize/resizeimagecommand
 */
import { Command } from 'ckeditor5/src/core';
/**
 * The resize image command. Currently, it only supports the width attribute.
 *
 * @extends module:core/command~Command
 */

var ResizeImageCommand = /*#__PURE__*/function (_Command) {
  _inherits(ResizeImageCommand, _Command);

  var _super = _createSuper(ResizeImageCommand);

  function ResizeImageCommand() {
    _classCallCheck(this, ResizeImageCommand);

    return _super.apply(this, arguments);
  }

  _createClass(ResizeImageCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils');
      var element = imageUtils.getClosestSelectedImageElement(editor.model.document.selection);
      this.isEnabled = !!element;

      if (!element || !element.hasAttribute('width')) {
        this.value = null;
      } else {
        this.value = {
          width: element.getAttribute('width'),
          height: null
        };
      }
    }
    /**
     * Executes the command.
     *
     *		// Sets the width to 50%:
     *		editor.execute( 'resizeImage', { width: '50%' } );
     *
     *		// Removes the width attribute:
     *		editor.execute( 'resizeImage', { width: null } );
     *
     * @param {Object} options
     * @param {String|null} options.width The new width of the image.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var editor = this.editor;
      var model = editor.model;
      var imageUtils = editor.plugins.get('ImageUtils');
      var imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
      this.value = {
        width: options.width,
        height: null
      };

      if (imageElement) {
        model.change(function (writer) {
          writer.setAttribute('width', options.width, imageElement);
        });
      }
    }
  }]);

  return ResizeImageCommand;
}(Command);

export { ResizeImageCommand as default };